import { defineStore } from 'pinia'

export const usePlayerStore = defineStore('playerStore', () => {
    const buildingChooser = useBuildingChooser()
    const apartmentChooser = useApartmentChooser()

    return { buildingChooser, apartmentChooser }
})
